import React from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import Collapsible from './Collapsible';

const StepSection = ({ label, steps }) => {
  if (!Array.isArray(steps) || steps.length === 0) return null;
  const sorted = steps
    .slice()
    .sort((a, b) => (a.step_number || 0) - (b.step_number || 0));
  return (
    <div className='tw-w-full tw-min-w-0 tw-flex tw-flex-col tw-gap-2'>
      <div className='tw-text-[1.2rem] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-grey-500 tw-px-1'>
        {label}
      </div>
      <div className='tw-w-full tw-min-w-0 tw-flex tw-flex-col tw-gap-2'>
        {sorted.map((step, idx) => (
          <Collapsible
            key={idx}
            defaultOpen={sorted.length === 1}
            title={
              sorted.length > 1
                ? `Step ${step.step_number}: ${step.title || ''}`
                : step.title || 'Prompt'
            }
            count={(step.guidelines || []).length}
          >
            <ul className='tw-m-0 tw-pl-6 tw-flex tw-flex-col tw-gap-1 tw-text-[1.3rem] tw-leading-relaxed tw-text-grey-700'>
              {(step.guidelines || []).map((g, gi) => (
                <li key={gi}>{g}</li>
              ))}
            </ul>
          </Collapsible>
        ))}
      </div>
    </div>
  );
};

const GuidelinesDrawer = ({
  title,
  sections = [],
  emptyText = 'Nothing to show.',
  onClose,
}) => {
  const hasContent = sections.some(
    (section) => Array.isArray(section.steps) && section.steps.length > 0,
  );

  const drawer = (
    <div
      className='tw-fixed tw-inset-0 tw-z-50 tw-flex tw-justify-end'
      onClick={onClose}
    >
      <div className='tw-absolute tw-inset-0 tw-bg-black/30' />

      <div
        className='tw-relative tw-bg-white tw-w-[480px] tw-max-w-full tw-h-full tw-flex tw-flex-col tw-shadow-2xl'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-border-0 tw-border-b tw-border-solid tw-border-grey-200'>
          <div className='tw-flex tw-items-center tw-gap-2'>
            <span className='tw-w-2 tw-h-2 tw-rounded-full tw-bg-base-green tw-shrink-0' />
            <span className='tw-text-[1.5rem] tw-font-semibold tw-text-grey-900 tw-font-mono'>
              {title}
            </span>
          </div>
          <button
            type='button'
            onClick={onClose}
            className='tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-1 tw-text-grey-500 hover:tw-text-grey-900'
          >
            <X size={18} />
          </button>
        </div>

        <div className='tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-5 tw-flex tw-flex-col tw-gap-6'>
          {!hasContent && (
            <div className='tw-text-[1.3rem] tw-text-grey-400 tw-text-center tw-py-10'>
              {emptyText}
            </div>
          )}
          {sections.map((section, idx) => (
            <StepSection
              key={idx}
              label={section.label}
              steps={section.steps}
            />
          ))}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(drawer, document.body);
};

export default GuidelinesDrawer;
